export default {
  'syslog.priority.g': {
    ko: 'Warning',
    ja: '警告',
    en: 'Warning',
    cn: '',
  },
  'syslog.grid.title': {
    ko: 'System Log List',
    ja: 'システムログリスト',
    en: 'System Log List',
    cn: '',
  },
  'abapdump.category.title': {
    ko: 'Message Category',
    ja: 'メッセージカテゴリ',
    en: 'Message Category',
    cn: '',
  },
  'applog.msgty.gr': {
    ko: 'Success or information',
    ja: '成功または情報',
    en: 'Success or information',
    cn: '',
  },
  'applog.message.title': {
    ko: 'Detail Message',
    ja: '詳細メッセージ',
    en: 'Detail Message',
    cn: '',
  },
  'syslog.message.title': {
    ko: 'Detail Message',
    ja: '詳細メッセージ',
    en: 'Detail Message',
    cn: '',
  },
  'applog.msgty.a': {
    ko: 'Abort',
    ja: '中止',
    en: 'Abort',
    cn: '',
  },
  'syslog.priority.r': {
    ko: 'Very high priority',
    ja: 'とても高い優先度',
    en: 'Very high priority',
    cn: '',
  },
  'applog.details.detail.title': {
    ko: 'Test User Exit',
    ja: 'ユーザー終了のテスト',
    en: 'Test User Exit',
    cn: '',
  },
  'applog.details.detail.std': {
    ko: 'Standard',
    ja: 'スタンダード',
    en: 'Standard',
    cn: '',
  },
  'syslog.field.title.details': {
    ko: 'Details',
    ja: '詳細',
    en: 'Details',
    cn: '',
  },
  'applog.details.detail.sub.title': {
    ko: 'This is the User exit test.',
    ja: 'これはユーザー終了のテストです。',
    en: 'This is the User exit test.',
    cn: '',
  },
  'applog.msgty.yt': {
    ko: 'Warning',
    ja: '警告',
    en: 'Warning',
    cn: '',
  },
  'applog.title': {
    ko: 'Application Log',
    ja: 'アプリログ',
    en: 'Application Log',
    cn: '',
  },
  'syslog.title': {
    ko: 'System Log',
    ja: 'システムログ',
    en: 'System Log',
    cn: '',
  },
  'applog.msgty.i': {
    ko: 'Information',
    ja: '情報',
    en: 'Information',
    cn: '',
  },
  'abapdump.title': {
    ko: 'ABAP Dump',
    ja: 'ABAPダンプ',
    en: 'ABAP Dump',
    cn: '',
  },
  'applog.msgty.e': {
    ko: 'Error',
    ja: 'エラー',
    en: 'Error',
    cn: '',
  },
  'applog.ltxts.detail.title': {
    ko: 'Performance Assitance',
    ja: 'パフォーマンスアシスタンス',
    en: 'Performance Assitance',
    cn: '',
  },
  'syslog.field.title.long.text': {
    ko: 'LText',
    ja: 'LText',
    en: 'LText',
    cn: '',
  },
  'applog.details.detail.param': {
    ko: 'Parameter',
    ja: 'パラメータ',
    en: 'Parameter',
    cn: '',
  },
  'applog.msgty.w': {
    ko: 'Warning',
    ja: '警告',
    en: 'Warning',
    cn: '',
  },
  'syslog.chart.title': {
    ko: 'System Log Transition',
    ja: 'システムログの遷移',
    en: 'System Log Transition',
    cn: '',
  },
  'abapdump.chart.title': {
    ko: 'ABAP Dump Transition',
    ja: 'ABAPダンプの遷移',
    en: 'ABAP Dump Transition',
    cn: '',
  },
  'applog.details.detail.msg': {
    ko: 'Message',
    ja: 'メッセージ',
    en: 'Message',
    cn: '',
  },
  'syslog.field.title.msg.text': {
    ko: 'Message text',
    ja: 'メッセージテキスト',
    en: 'Message text',
    cn: '',
  },
  'applog.msgty.s': {
    ko: 'Success',
    ja: '成功',
    en: 'Success',
    cn: '',
  },
  'syslog.priority.w': {
    ko: 'Information',
    ja: '情報',
    en: 'Information',
    cn: '',
  },
  'syslog.priority.y': {
    ko: 'High priority',
    ja: '高い優先度',
    en: 'High priority',
    cn: '',
  },
  'applog.msgty.empty': {
    ko: 'Others',
    ja: 'その他',
    en: 'Others',
    cn: '',
  },
  'abapdump.message.title': {
    ko: 'Detail Message',
    ja: '詳細メッセージ',
    en: 'Detail Message',
    cn: '',
  },
  'applog.chart.title': {
    ko: 'Application Log Transition',
    ja: 'アプリログの遷移',
    en: 'Application Log Transition',
    cn: '',
  },
  'syslog.field.title.type': {
    ko: 'Type',
    ja: 'タイプ',
    en: 'Type',
    cn: '',
  },
  'applog.msgty.rc': {
    ko: 'Error or abort',
    ja: 'エラーまたは中止',
    en: 'Error or abort',
    cn: '',
  },
  'applog.grid.title': {
    ko: 'Application Log List',
    ja: 'アプリログリスト',
    en: 'Application Log List',
    cn: '',
  },
  'abapdump.grid.title': {
    ko: 'ABAP Dump List',
    ja: 'ABAPダンプリスト',
    en: 'ABAP Dump List',
    cn: '',
  },
};
